import dynamic from "next/dynamic";

export const DynamicCommandPaletteContainer = dynamic(
  async () => (await import("@/components/command-palette/CommandPalette")).CommandPaletteContainer,
  {
    loading: () => null,
    ssr: false,
  },
);
